// SHAPE seats on the Pantheon: each sector's podium holds the deity ATLAS shows for that sector (its
// Endeavour's deity tag, or the saved Goal when it's on the roster). No Endeavour → an empty podium.
// Re-reads on every ATLAS save, so changing the Endeavour swaps the deity straight away.
import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";
import { loadAtlas, onAtlasSaved } from "../olmps/atlas-data";
import { currentDeity } from "../olmps/atlas-tree";
import { SECTORS, type Sector } from "../domain/olmps";
import { SHAPE_BY_ID, type ShapeDeity } from "./shapeRoster";

export type ShapeSeats = Record<Sector, ShapeDeity | undefined>;

const EMPTY: ShapeSeats = {
  S: undefined,
  H: undefined,
  A: undefined,
  P: undefined,
  E: undefined,
};

/** Loads when `active` turns on and again after each ATLAS save. */
export function useShapeSeats(
  userId: string | undefined,
  active: boolean,
): ShapeSeats {
  const [seats, setSeats] = useState<ShapeSeats>(EMPTY);
  const [rev, setRev] = useState(0);
  useEffect(() => onAtlasSaved(() => setRev((r) => r + 1)), []);
  useEffect(() => {
    if (!userId || !active) return;
    let live = true;
    loadAtlas(supabase, userId)
      .then((spine) => {
        if (!live) return;
        const next = { ...EMPTY };
        for (const s of SECTORS) {
          const n = spine[s];
          next[s] =
            n?.endeavour || SHAPE_BY_ID[n?.goal ?? ""]
              ? SHAPE_BY_ID[currentDeity(s, n?.goal, n?.endeavour) ?? ""]
              : undefined;
        }
        setSeats(next);
      })
      .catch(() => undefined);
    return () => {
      live = false;
    };
  }, [userId, active, rev]);
  return seats;
}
